<template>
  <block-item-card
    :min-height="minBlockHeight"
    :show-border="false"
    class="gradient-grey-06-bg"
    style="padding: 18px !important;"
  >
    <div class="bank-readiness-container">
      <!-- Header -->
      <div class="d-flex align-center mb-4">
        <span class="bullet-point">•</span>
        <h3 class="main-title">
          {{ $t('Dashboard.Banking.LiquidityRisk.BankReadiness.Title') }}
        </h3>
      </div>

      <!-- Column Headers -->
      <div class="column-headers mb-2">
        <div class="scenarios-header">
          {{ $t('Dashboard.Banking.LiquidityRisk.BankReadiness.Scenarios') }}
        </div>
        <div class="adequacy-header">
          {{ $t('Dashboard.Banking.LiquidityRisk.BankReadiness.Adequacy') }}
        </div>
      </div>

      <!-- Scenario Rows -->
      <div class="scenario-rows">
        <div
          v-for="scenario in bankReadinessScenarios"
          :key="scenario.type"
          class="scenario-row"
        >
          <div class="scenario-left">
            <div
              :class="['scenario-indicator', scenario.type]"
            />
            <div class="scenario-text">
              {{ scenario.title }}
            </div>
          </div>
          <div class="scenario-right">
            <div
              class="checkmark-indicator"
              :class="{'checkmark-indicator-not-survived': !scenario.survived}"
            >
              <v-icon
                color="white"
                size="14"
              >
                {{ scenario.survived ? 'mdi-check' : 'mdi-close' }}
              </v-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </block-item-card>
</template>

<script>
import routerTabState        from '@/mixins/routerTabState'
import BlockItemCard from '@/theme/default/components/common/BlockItemCard.vue'

export default {
  name      : 'BankReadiness',
  components: {
    BlockItemCard
  },
  directives: {},
  mixins    : [routerTabState],
  dataStore : {
    BankingDashboard: 'BankingDashboard.Data'
  },
  enums    : {},
  dataModel: null,
  data () {
    return {
      minBlockHeight: 254
    }
  },
  computed: {
    accountId () {
      return this.user?.selectedAccountId || null
    },
    bankReadinessData () {
      return [...this.BankingDashboard?.liquidityRiskDashboard?.bankReadinessDashboardScenarios || []].reverse()
    },
    bankReadinessScenarios () {
      if (this.bankReadinessData && Array.isArray(this.bankReadinessData)) {
        return this.bankReadinessData.map(scenario => ({
          type    : (scenario.crisisScenario || scenario.CrisisScenario).toLowerCase(),
          title   : scenario.displayCrisisScenario || scenario.DisplayCrisisScenario,
          survived: scenario.survived || scenario.Survived
        }))
      }

      return [

      ]
    }
  },
  created () {},
  methods: {}
}
</script>

<style scoped>
.gradient-grey-06-bg {
  background-color: white !important;
}

.bullet-point {
  color: var(--v-synthesis-ui-grey-01-base);
  font-size: 16px;
  font-weight: bold;
  margin-right: 8px;
  display: inline-block;
}

.main-title {
  font-family: Inter, Aeonik, Roboto, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 100%;
  margin: 0;
  color: var(--v-synthesis-ui-grey-01-base);
}

.column-headers {
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
}

.scenarios-header,
.adequacy-header {
  font-size: 11px;
  font-weight: 500;
  color: var(--v-synthesis-ui-grey-01-base);
}

.scenario-rows {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.scenario-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 16px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.scenario-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.scenario-indicator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mild {
  background: radial-gradient(circle at 30% 30%, #ffb74d, #ff9800);
  box-shadow: 0 0 8px rgba(255, 152, 0, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.severe {
  background: radial-gradient(circle at 30% 30%, #ffab91, #ff7043);
  box-shadow: 0 0 8px rgba(255, 112, 67, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.panic {
  background: radial-gradient(circle at 30% 30%, #ef5350, #f44336);
  box-shadow: 0 0 8px rgba(244, 67, 54, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.scenario-text {
  font-size: 13px;
  font-weight: 500;
  color: var(--v-synthesis-ui-grey-01-base);
}

.scenario-right {
  display: flex;
  align-items: center;
}

.checkmark-indicator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  background-color: var(--v-synthesis-ui-green-02-base);
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.checkmark-indicator-not-survived {
 background-color: var(--v-synthesis-ui-red-02-base);
}
</style>
